import { Component, OnInit, HostListener } from '@angular/core';
import { HelpersService } from '../../../../services/helpers.service';
import { AppConfig } from '../../../../app.config';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-super-user-portal',
  templateUrl: './super-user-portal.component.html',
  styleUrls: ['./super-user-portal.component.scss'],
})
export class SuperUserPortalComponent implements OnInit {
  public menuOpen = true;
  public dropMenuOpen = false;
  public userName: string = '';
  public profile: any = {};
  public partner: any = {};
  public showShadow = false;
  public IsDev: boolean = this.appConfig.isDev();

  public readonly superUserMenuItems = [
    {
      label: 'Quicklinks',
      separator: true,
      items: [
        {
          label: 'Analytics',
          icon: 'report',
          routerLink: ['/administration/analytics'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Embedded Report',
          icon: 'embed-chart',
          routerLink: ['/administration/reports'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Stores',
          icon: 'building',
          routerLink: ['/administration/stores'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Admin Tasks',
          icon: 'laptop-alt',
          routerLink: ['/administration/admin-tasks'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Error Logs',
          icon: 'bug',
          routerLink: ['/administration/errors'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Customers',
          icon: 'people',
          routerLink: ['/administration/customers'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Messaging Bundles',
          icon: 'message-circle',
          routerLink: ['/administration/messaging-bundles'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Create a Club',
          icon: 'house-line',
          routerLink: ['/club-setup-wizard'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Gear Management',
          icon: 'settings-gear',
          routerLink: ['/administration/bike-gear-management'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Trails',
          icon: 'location-arrow',
          routerLink: ['/administration/trails-management'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Push Notification Broadcast',
          icon: 'send-alt-2',
          routerLink: ['/administration/push-notification-broadcast'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Token Management',
          icon: 'shield_check_duo',
          routerLink: ['/administration/token-management'],
          command: () => {
            this.closeMenu();
          },
        },
        {
          label: 'Sync Progress',
          icon: 'refresh',
          routerLink: ['/administration/sync-progress'],
          command: () => {
            this.closeMenu();
          },
        },
      ],
    },
  ];

  public readonly superUserToolsItems = [
    /*{
      label: 'Tools', icon: 'fa fa-fw fa-wrench', items: [
      ]
    }*/
  ];

  constructor(
    public appConfig: AppConfig,
    public helpersService: HelpersService,
    public router: Router,
  ) {}
  ngOnInit() {
    this.appConfig.populateData();
    this.getUserProfile();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    let pos =
      (document.documentElement.scrollTop || document.body.scrollTop) +
      document.documentElement.offsetHeight;
    let max = document.documentElement.scrollHeight;

    if (pos == max) {
      this.showShadow = false;
    } else {
      this.showShadow = true;
    }
  }

  getUserProfile() {
    var localSorage = this.helpersService.getAuthData();
    if (localSorage && localSorage.username) {
      this.profile = this.helpersService.getProfileData();
      if (!this.profile.IsSuperUser) {
        this.router.navigateByUrl('/store/calendar');
      }
    } else {
      this.helpersService.removeTokenAndLogout();
      this.router.navigateByUrl('/');
    }
  }

  logout() {
    this.helpersService.removeTokenAndLogout();
    this.router.navigateByUrl('/');
  }

  closeMenu() {
    if (!this.menuOpen) {
      this.menuOpen = !this.menuOpen;
    }
  }
}
